import React from 'react';
import './ProjectImage.css';

const ProjectImage = ({ gradient, icon: Icon, title, images, videos }) => {
  // Show video if available
  if (videos && videos.length > 0) {
    return (
      <div className="project-image-container">
        <video
          src={videos[0]}
          controls
          className="project-main-image"
          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
        />
      </div>
    );
  }

  if (images && images.length > 1) {
    return (
      <div className="project-image-container">
        <img
          src={images[0]}
          alt={title}
          className="project-main-image"
          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
        />
      </div>
    );
  }

  if (images && images.length === 1) {
    return (
      <div className="project-image-container">
        <img
          src={images[0]}
          alt={title}
          className="project-main-image"
          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
        />
      </div>
    );
  }

  return (
    <div className="project-image-container" style={{ background: gradient }}>
      <div className="project-image-overlay">
        <div className="project-image-content">
          {Icon && <Icon className="project-image-icon" />}
          <div className="project-image-pattern"></div>
        </div>
      </div>
    </div>
  );
};

export default ProjectImage;
